const BrandRecommended: React.FC = () => {
  return <>BrandRecommended</>;
};
export default BrandRecommended;
